<template>
  <Badge v-if="infantCareQualified" icon="child_friendly">
    {{ infantCareQualified ? "Infant Care Qualified" : null }}
  </Badge>
</template>

<script>
import Badge from "@/components/UI/Badge.vue";

export default {
  name: "InfantCareQualified",
  props: ["infantCareQualified"],
  components: {
    Badge,
  },
};
</script>
